import React from 'react';
import { useToggleRefinement, UseToggleRefinementProps } from 'react-instantsearch';

export const VirtualToggleRefinement: React.FC<UseToggleRefinementProps> = (props) => {
    useToggleRefinement(props);

    return null;
};
